import React, { useEffect, useState, useRef } from 'react'
import JoditEditor from 'jodit-react'
// import 'jodit/build/jodit.min.css'

const defaultConfig = {
  readonly: false,
  height: 300,
  toolbarButtonSize: 'middle',
  toolbarAdaptive: false,
  showXPathInStatusbar: false,
  showCharsCounter: false,
  showWordsCounter: false,
  toolbar: [
    'bold',
    'italic',
    'underline',
    'strikethrough',
    'ul',
    'ol',
    'link',
    'image',
    'video',
    'code',
    'source'
  ]
}

const CommonJoditEditor = ({
  value = '',
  onChange,
  config = {},
  placeholder = '',
  showHtmlToggle = true,
  saveButtonLabel = 'Save HTML',
  className = ''
}) => {
  const [showSource, setShowSource] = useState(false)
  const [rawHtml, setRawHtml] = useState(value || '')
  const [editorKey, setEditorKey] = useState(0)
  const joditRef = useRef(null)

  useEffect(() => {
    setRawHtml(value || '')
    setEditorKey((k) => k + 1)
  }, [value])

  const handleSave = () => {
    onChange(rawHtml)
    setShowSource(false)
  }

  return (
    <div className={className}>
      {showHtmlToggle && (
        <div className="mb-2">
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary mr-2"
            onClick={() => setShowSource((prev) => !prev)}
          >
            {showSource ? 'Editor' : 'HTML'}
          </button>
          {showSource && (
            <button
              type="button"
              className="btn btn-sm btn-primary"
              onClick={handleSave}
            >
              {saveButtonLabel}
            </button>
          )}
        </div>
      )}

      {showSource ? (
        <textarea
          className="form-control"
          style={{ minHeight: 300 }}
          value={rawHtml}
          onChange={(e) => setRawHtml(e.target.value)}
          placeholder={placeholder}
        />
      ) : (
        <JoditEditor
          ref={joditRef}
          key={`${editorKey}`}
          value={value || ''}
          config={{ ...defaultConfig, ...config, height: 300 }}
          tabIndex={1}
          onBlur={(newContent) => onChange(newContent)}
        />
      )}
    </div>
  )
}

export default CommonJoditEditor
